import React, {useEffect, useState} from 'react';

import {getUserTypes} from '../DropdownDataProviders' ;
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";
import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownUserTypes = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getUserTypes(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownUserTypes;

DropdownUserTypes.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownUserTypes.propTypes = {
    onChange: PropTypes.func.isRequired
};